import { useEffect, useRef, useState } from 'react';
import { useAppSelector } from '../state';
import { selectFeatureFlags } from '../state/slices/slice-link-params';
var LOADING_SKELETON_DURATION_MS = 300;
export var useLoadingSkeleton = function (enabled) {
    if (enabled === void 0) { enabled = true; }
    var featureFlags = useAppSelector(selectFeatureFlags);
    var loadingSkeletonEnabled = enabled && featureFlags.screenTransitionLoadingSkeleton;
    var _a = useState(
    // If enabled, then show the loading skeleton on component mount.
    loadingSkeletonEnabled), showLoadingSkeleton = _a[0], setShowLoadingSkeleton = _a[1];
    var loadingSkeletonTimeoutId = useRef(null);
    useEffect(function () {
        if (loadingSkeletonEnabled) {
            loadingSkeletonTimeoutId.current = setTimeout(function () {
                setShowLoadingSkeleton(false);
            }, LOADING_SKELETON_DURATION_MS);
        }
        // Cleanup so we don't do a state update if the component unmounted
        return function () {
            if (loadingSkeletonTimeoutId.current !== null) {
                clearTimeout(loadingSkeletonTimeoutId.current);
                loadingSkeletonTimeoutId.current = null;
            }
        };
    }, [loadingSkeletonEnabled]);
    return { showLoadingSkeleton: showLoadingSkeleton };
};
